import { useContext } from "react";
import { AuthContext } from "../providers/authProvider";

const App = () => useContext(AuthContext);
export default App;
